/** The (task, visitDate) pair an Upcoming Work row's composite `_id` (`${taskId}:${visitDate}`) names. */
export interface UpcomingWorkRowId {
    taskId: string;
    visitDate: string;
}

const LOCAL_DATE = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Split on the LAST ':' — the date is the half whose shape is guaranteed (ten trailing characters),
 * so anchoring on it stays correct if a task id ever carries a colon. Null for a malformed id so
 * the caller can raise its own transport error; this is shared model code with no HTTP vocabulary.
 */
export function parseUpcomingWorkRowId(id: string | null | undefined): UpcomingWorkRowId | null {

    const separator = id?.lastIndexOf(':') ?? -1;
    const taskId = separator > 0 ? id!.slice(0, separator) : '';
    const visitDate = separator > 0 ? id!.slice(separator + 1) : '';
    return taskId && isCalendarDate(visitDate) ? { taskId, visitDate } : null;
}

/** Shape AND calendar: `2026-13-40` has the shape but no such day, and would otherwise mint a ghost row. */
function isCalendarDate(value: string): boolean {

    if (!LOCAL_DATE.test(value)) return false;
    const parsed = new Date(`${value}T00:00:00.000Z`);
    return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}
